import { useTranslation } from 'react-i18next'
import Icon from '@/components/ui/icon'

export default function Thesis() {
  const { t } = useTranslation()

  return (
    <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 lg:gap-16 mb-16 md:mb-32 lg:mb-48">
      {/* Left column: title + thesis box */}
      <div className="md:col-span-4">
        <h2 className="font-display text-2xl font-bold uppercase tracking-widest text-on-surface mb-10 border-b border-outline-variant pb-4">
          {t('manifesto.thesis.title')}
        </h2>
        <div className="bg-surface-container-high p-5 md:p-8">
          <p className="text-on-surface-variant leading-relaxed text-lg mb-6">
            {t('manifesto.thesis.box1')}
          </p>
          <p className="text-on-surface-variant leading-relaxed opacity-70">
            {t('manifesto.thesis.box2')}
          </p>
        </div>
      </div>

      {/* Right column: multi-column narrative */}
      <div className="md:col-span-8 space-y-12">
        <div className="columns-1 md:columns-2 gap-12 space-y-12 text-on-surface-variant font-light text-base leading-loose">
          <p>{t('manifesto.thesis.narrative1')}</p>

          <div className="break-inside-avoid border-l border-primary/30 pl-8 my-8">
            <Icon name="security" filled className="text-primary mb-4 text-2xl" />
            <h3 className="text-on-surface font-display font-bold mb-4">
              {t('manifesto.thesis.immutableTitle')}
            </h3>
            <p className="text-sm">{t('manifesto.thesis.immutableText')}</p>
          </div>

          <p>{t('manifesto.thesis.narrative2')}</p>

          <div className="break-inside-avoid bg-surface-container-highest/30 p-8">
            <h4 className="text-primary font-body text-[10px] uppercase tracking-[0.4em] mb-4">
              {t('manifesto.thesis.principleLabel')}
            </h4>
            <p className="text-on-surface font-display text-xl font-medium tracking-tight">
              {t('manifesto.thesis.principleText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
